import styled from "styled-components";
import BreadCrumbs from "../../components/ui-v2/BreadCrumbs";
import ExtraLargeButton from "../../components/ui-v2/ExtraLargeButton";
import { useNavigationManager } from "../../hooks/useNavigationManager";
import { ROUTES } from "../../router";
import { useEffect, useRef, useState } from "react";
import { localStorageConstants } from "../../utils/constants";
import { TAccount } from "../../redux/reducers/account";
import {
  getQuerystringParams,
  handleGetDataFromLocalStorage,
} from "../../utils/miscellaneous";
import { useTypedSelector } from "../../hooks/useTypedSelector";
import axios, { CancelTokenSource } from "axios";
import { fetchMemberships } from "../../redux/actions";
import { useTypedDispatch } from "../../hooks/useTypedDispatch";

const Container = styled.main`
  h1 {
    font-family: var(--font-title-bold);
    font-size: 28px;
    color: var(--color-text-title);
    margin-top: 10px;
  }

  & > *:nth-child(1) {
    margin-top: 20px;
  }
`;

const ContentContainer = styled.section`
  display: flex;
  margin-top: 30px;
  justify-content: space-between;

  .buttonContainer {
    width: calc(100% - 150px);
    display: flex;
    justify-content: center;
  }

  & *:not(& *:last-child) {
    margin-right: 24px;
  }
`;

const AccountCard = styled.article`
  display: flex;
  flex-direction: column;

  width: calc(214vw / 14.4);

  padding: 20px 16px;

  border: 1px solid var(--color-dark-blue-300);
  border-radius: 16px;

  h2 {
    font-family: var(--font-title-bold);
    font-size: 21px;
    color: var(--color-dark-blue-700);
  }

  p {
    color: var(--color-dark-blue-500);
    font-size: 14px;
    font-family: var(--font-paragraph-default);
  }

  p:not(:last-child) {
    margin-bottom: 16px;
  }

  p span {
    color: var(--color-dark-blue-600);
    font-size: 14px;
    font-family: var(--font-paragraph-bold);
  }
`;

const Config: React.FC = () => {
  const { goTo } = useNavigationManager();

  const cancelTokenSource = useRef<CancelTokenSource | null>(null);

  const [membershipsCount, setMembershipsCount] = useState(0);
  const [selectAccountName, setSelectAccountName] = useState("");

  const selectedOrganization = useTypedSelector(
    (state) => state.organizations.selectedOrganization
  );

  const organizationsCount = useTypedSelector(
    (state) => state.organizations?.data?.count ?? 0
  );

  const { setQuerystring } = useNavigationManager();

  const dispatch = useTypedDispatch();

  const reduxQuerystring = useTypedSelector((state) => state.querystring);

  const onClickUsersHandler = () => {
    goTo(ROUTES.SETTINGS_USERS, reduxQuerystring);
  };

  const onClickOrgsHandler = () => {
    goTo(ROUTES.SETTINGS_ORGANIZATIONS, reduxQuerystring);
  };

  const fetchData = async () => {
    const localSelectAccount = handleGetDataFromLocalStorage(
      localStorageConstants.SELECT_ACCOUNT
    ) as TAccount;

    if (localSelectAccount) {
      cancelTokenSource.current = axios.CancelToken.source();

      let membershipsResponse = await dispatch(
        fetchMemberships({
          cancelToken: cancelTokenSource.current.token,
        })
      ).unwrap();
      if (membershipsResponse) {
        setMembershipsCount(membershipsResponse.count);
      }
      setSelectAccountName(localSelectAccount.name);
    }
  };

  useEffect(() => {
    if (
      selectedOrganization &&
      selectedOrganization.permissions &&
      selectedOrganization.permissions &&
      !selectedOrganization.permissions.organization_management &&
      !selectedOrganization.permissions.user_management
    ) {
      goTo(ROUTES.HOME + window.location.search);
    }
  }, [selectedOrganization]);

  useEffect(() => {}, [membershipsCount, organizationsCount]);

  useEffect(() => {
    const querystring = getQuerystringParams();
    if (querystring.page) {
      querystring.page = 1;
    }

    if (querystring.search) {
      delete querystring.search;
    }

    if (querystring.role) {
      delete querystring.role;
    }

    if (querystring.status) {
      delete querystring.status;
    }

    setQuerystring(querystring);

    setTimeout(async () => {
      fetchData();
    });

    return () => {
      if (cancelTokenSource.current) cancelTokenSource.current.cancel();
    };
  }, []);

  return (
    <Container>
      <BreadCrumbs
        names={["Início", "Configurações"]}
        urls={[ROUTES.HOME, ROUTES.SETTINGS]}
      />
      <h1>Configurações</h1>
      <ContentContainer>
        <AccountCard key={membershipsCount + "-" + organizationsCount}>
          <h2>Conta</h2>
          <p>{selectAccountName}</p>
          <p>
            Organizações:&nbsp;<span>{organizationsCount}</span>
          </p>
          <p>
            Usuários:&nbsp;<span>{membershipsCount}</span>
          </p>
        </AccountCard>
        {selectedOrganization &&
          selectedOrganization.permissions?.organization_management && (
            <div
              className={
                !selectedOrganization.permissions?.user_management
                  ? "buttonContainer"
                  : ""
              }
            >
              <ExtraLargeButton
                maxWidth={reduxQuerystring.sidebar_fixed ? "340px" : "550px"}
                onClick={onClickOrgsHandler}
                variant="orgs"
              />
            </div>
          )}
        {selectedOrganization &&
          selectedOrganization.permissions?.user_management && (
            <div
              className={
                !selectedOrganization.permissions?.organization_management
                  ? "buttonContainer"
                  : ""
              }
            >
              <ExtraLargeButton
                maxWidth={reduxQuerystring.sidebar_fixed ? "340px" : "550px"}
                onClick={onClickUsersHandler}
                variant="users"
              />
            </div>
          )}
      </ContentContainer>
    </Container>
  );
};

export default Config;
